// Reusable VALOR logo block. Variants: header (small/light) and footer (large/dark).
// Pure CSS — designed to be replaced with an SVG/logo asset later by swapping
// the inner block. The wordmark + emblem composition stays intact.

export default function Logo({
  size = "md",
  variant = "light",
  showSub = true,
  showWordmark = true,
  wordmark = "VALOR",
  sub = "Defense Energetics",
  emblem = "V",
}) {
  const sizes = {
    sm: { box: "w-10 h-10", text: "text-xl", subText: "text-[11px]", emblem: "text-lg" },
    md: { box: "w-12 h-12 md:w-14 md:h-14", text: "text-2xl md:text-3xl", subText: "text-[14px]", emblem: "text-2xl md:text-3xl" },
    lg: { box: "w-14 h-14 md:w-16 md:h-16", text: "text-3xl md:text-4xl", subText: "text-[14.5px]", emblem: "text-3xl md:text-4xl" },
    xl: { box: "w-24 h-24 md:w-32 md:h-32", text: "text-5xl md:text-7xl lg:text-8xl", subText: "text-xs md:text-sm", emblem: "text-5xl md:text-7xl lg:text-8xl" },
  };
  // When wordmark is hidden, make the emblem box ~1.5x larger for proper presence
  const emblemOnlySizes = {
    sm: "w-12 h-12",
    md: "w-16 h-16 md:w-20 md:h-20",
    lg: "w-20 h-20 md:w-24 md:h-24",
    xl: "w-28 h-28 md:w-36 md:h-36",
  };
  const emblemOnlyText = {
    sm: "text-2xl",
    md: "text-3xl md:text-4xl",
    lg: "text-4xl md:text-5xl",
    xl: "text-6xl md:text-8xl",
  };
  const s = sizes[size] || sizes.md;
  const dark = variant === "dark";
  const boxClass = showWordmark ? s.box : (emblemOnlySizes[size] || emblemOnlySizes.md);
  const emblemTextClass = showWordmark ? s.emblem : (emblemOnlyText[size] || emblemOnlyText.md);

  return (
    <div className="flex items-center gap-3 md:gap-4" data-testid="valor-logo">
      <div className={`relative ${boxClass} flex items-center justify-center shrink-0`}>
        <img
          src="/valor-mark.png"
          alt="Valor Tactical eagle mark"
          className="w-full h-full object-contain"
          loading="eager"
          decoding="async"
        />
      </div>
      {showWordmark && (
        <div className="leading-none">
          <div
            className={`font-display font-bold tracking-tight ${s.text} ${
              dark ? "text-white" : "text-navy"
            }`}
          >
            {wordmark}
          </div>
          {showSub && (
            <div
              className={`font-mono tracking-[0.28em] uppercase mt-1.5 max-w-[26ch] leading-snug ${s.subText} ${
                dark ? "text-white/82" : "text-steel"
              }`}
            >
              {sub}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
